import { Link } from "react-router-dom";
import { SEO } from "../components/SEO";
import { SITE } from "../data/site";

export default function NotFound() {
  return (
    <section className="noise-dark flex min-h-[70vh] items-center pt-24 text-zinc-100">
      <SEO title="Page not found | Duct Clean Co." description="The page you requested does not exist." robots="noindex, nofollow" />
      <div className="container-x py-24">
        <p className="font-mono text-xs uppercase tracking-[0.3em] text-dcc-strong">404 — Off the map</p>
        <h1 className="h-display mt-6 text-5xl text-zinc-50 sm:text-6xl">This run doesn't exist.</h1>
        <p className="mt-6 max-w-md text-sm leading-relaxed text-zinc-400">
          The route you followed isn't part of the system. Head back to surveyed territory.
        </p>
        <div className="mt-10 flex flex-wrap gap-4">
          <Link to="/" data-testid="notfound-home-link" className="btn-primary">Back to Home</Link>
          <Link to={SITE.cta.to} data-testid="notfound-survey-link" className="btn-ghost text-zinc-200 hover:bg-zinc-100 hover:text-charcoal">{SITE.cta.label}</Link>
        </div>
      </div>
    </section>
  );
}
